module.exports = __webpack_public_path__ + "static/media/Buneary_gaussian2.cb5e7bcd.png";